import authService from './authService';

export interface Course {
  course_id: string;
  course_name: string;
  course_description: string;
  tracks: string[] | string; 
  track_names: string;
  course_level: string;
  batch_count?: number;
  days?: number;
  students_count: number;
  del_row: boolean;
  start_date?: string | null;
  end_date?: string | null;
}

/**
 * Fetch all courses from the API
 * @returns Promise<Course[]> Array of course objects
 */
export const fetchAllCourses = async (): Promise<Course[]> => {
  try {
    const response = await authService.get('admin/get_all_courses/');
    
    if (response.status !== 200 && response.status !== 201) {
      throw new Error('Failed to fetch courses');
    }
    
    return response.data.courses || [];
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

/**
 * @param trackId 
 * @returns 
 */
export const fetchCoursesByTrack = async (trackId: string): Promise<Course[]> => {
  try {
    const response = await authService.get(`admin/get_all_courses/?track_id=${trackId}`);
    
    if (response.status !== 200 && response.status !== 201) {
      throw new Error('Failed to fetch courses');
    }
    
    return response.data.courses || [];
  } catch (error) {
    console.error('Error fetching courses by track:', error);
    throw error;
  }
};

export interface CourseSubjectOption {
  subject_id: string;
  subject_name: string;
}

/**
 * Subjects present in ALL selected courses (intersection).
 */
export const fetchSubjectsOfCourses = async (
  courseIds: string[]
): Promise<CourseSubjectOption[]> => {
  if (!courseIds.length) return [];
  const response = await authService.post('admin/get_subjects_of_courses/', {
    course_ids: courseIds,
  });
  const subjects = response.data?.subjects;
  if (!Array.isArray(subjects)) return [];
  return subjects.map((row: { subject_id: string; subject_name: string }) => ({
    subject_id: String(row.subject_id),
    subject_name: String(row.subject_name),
  }));
};

